import { OnInit, OnDestroy, Component, Directive } from "@angular/core";
import { Subscription, Observable } from "rxjs";

@Directive()
export class UtilsComponent implements OnInit, OnDestroy {
    protected subscriptions: Subscription[] = [];

    ngOnInit() {}

    ngOnDestroy() {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
        this.subscriptions = [];
    }

    protected register(sub: Subscription) {
        this.subscriptions.push(sub);
    }

    protected unregister(sub: Subscription) {
        sub.unsubscribe();
        this.subscriptions = this.subscriptions.filter((s) => s !== sub);
    }
}
